/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_B3_TechnologyInputs */

const cs_enum_b3_technology = /** @type {(inputs: Enum_B3_TechnologyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B3 Technology`)
};

const en_enum_b3_technology = /** @type {(inputs: Enum_B3_TechnologyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B3 Technology`)
};

/**
* | output |
* | --- |
* | "B3 Technology" |
*
* @param {Enum_B3_TechnologyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_b3_technology = /** @type {((inputs?: Enum_B3_TechnologyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_B3_TechnologyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_b3_technology(inputs)
	return cs_enum_b3_technology(inputs)
});